export enum PaymentType {
  UseExistingCreditCard = 'use-existing-credit-card',
  PayWithDifferentCard = 'pay-with-different-card',
}
